import {
  ChatBotIcon,
  ChatBotLogo,
  ChatDownIcon,
  CloseIcon,
} from '@/assets/icons'
import { useEffect, useState } from 'react'
import axios from 'axios'
import type { MessagesWithAds, UserData } from '../chat'
import Chat from '../chat'
import PdfModal from '../PdfModal'
import UserForm, { FormData } from './UserForm'
import InstallPWAButton from '../PWAInstallButton'
import { jwtDecode, type JwtPayload } from 'jwt-decode'
import { API_URL } from '@/constant/api'

interface GuestTokenPayload extends JwtPayload {
  name: string
  email: string
  userId: string
}

interface ChatWidgetProps {
  siteName?: string
  defaultOpen?: boolean
}

const ChatWidget = ({ siteName, defaultOpen }: ChatWidgetProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen ?? false)
  const [userData, setUserData] = useState<UserData | null>(null)
  const [openPdfModal, setOpenPdfModal] = useState(false)
  const toggleChat = () => setIsOpen(prev => !prev)
  const [messagesWithAds, setMessagesWithAds] = useState<MessagesWithAds[]>([
    {
      userQuery: '',
      response: "Hey there, I'm ProInstaller AI. How can I help you today?",
      type: 'message',
      timestamp: new Date().toISOString(),
    },
  ])

  useEffect(() => {
    const token = localStorage.getItem('guestToken')
    if (!token) return
    try {
      const decoded = jwtDecode<GuestTokenPayload>(token)
      const now = Date.now() / 1000
      const expiresIn = decoded?.exp || 0

      if (expiresIn < now) {
        localStorage.removeItem('guestToken')
        return
      }
      setUserData({
        name: decoded.name,
        email: decoded.email,
        userId: decoded.userId,
      })
    } catch {
      localStorage.removeItem('guestToken')
    }
  }, [])

  const handleFormSubmit = (data: FormData) => {
    const user = {
      name: data.Name,
      email: data.Email,
      userId: crypto.randomUUID(),
    }
    axios
      .post(`${API_URL}/auth/guest-token`, user)
      .then(response => {
        localStorage.setItem('guestToken', JSON.stringify(response.data.token))
        localStorage.setItem('userData', JSON.stringify(user))
        setUserData(user)
      })
      .catch(error => console.error(error))
  }
  return (
    <>
      {/* <PdfForm /> */}

      {!siteName && (
        <div className='fixed bottom-6 right-6 z-50 flex flex-col items-center gap-2'>
          <button type='button' onClick={toggleChat} className='cursor-pointer'>
            {isOpen ? <ChatDownIcon /> : <ChatBotIcon />}
          </button>
          <div className='pointer-events-none max-w-[min(90vw,280px)] rounded-md bg-[#383838] px-3 py-2 text-center text-xs font-medium leading-snug text-white shadow-md'>
            <span className='chat-widget-promo-caption'>
              ProInstaller AI <br className='chat-widget-promo-break' />
              ask a flooring question
            </span>
          </div>
        </div>
      )}
      {/* Chat Box */}

      <div
        className={` fixed flex flex-col justify-center  right-0 bg-[#F8F9FA] overflow-hidden 
                    ${siteName ? 'w-full h-full' : 'rounded-[12px] w-full bottom-[158px] md:right-6 md:w-[90vw] md:max-w-[320px] md:z-50'}
                    ${isOpen ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'}
                    `}
      >
        <div className='w-full max-w-[520px] mx-auto'>
          <div className='bg-[#383838] text-white text-[16px] font-bold flex justify-between items-center px-5 py-3'>
            <div className='flex items-center gap-[10px] flex-wrap'>
              <span>
                <ChatBotLogo />
              </span>
              <span className='chat-widget-promo-caption'>
                <span className='text-[16px]'>ProInstaller AI</span>{' '}
                <br className='chat-widget-promo-break' />
                <span className='text-[12px]'>ask a flooring question</span>
              </span>
            </div>
            <div className='flex items-center gap-[15px]'>
              <InstallPWAButton />
              {!siteName && (
                <>
                  <button className='cursor-pointer' onClick={toggleChat}>
                    <CloseIcon />
                  </button>
                  <div className='pointer-events-none max-w-[min(90vw,280px)] rounded-md bg-[#383838] px-3 py-2 text-center text-xs font-medium leading-snug text-white shadow-md'>
                    <span className='chat-widget-promo-caption'>
                      ProInstaller AI <br className='chat-widget-promo-break' />
                      ask a flooring question
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>

          {!userData ? (
            <UserForm
              handleFormSubmit={handleFormSubmit}
              siteName={siteName ?? ''}
            />
          ) : (
            <Chat
              siteName={siteName ?? ''}
              openPdfModal={openPdfModal}
              setOpenPdfModal={setOpenPdfModal}
              setMessagesWithAds={setMessagesWithAds}
              messagesWithAds={messagesWithAds}
            />
          )}
        </div>
      </div>
      <PdfModal
        isOpen={openPdfModal}
        onClose={() => setOpenPdfModal(false)}
        userData={userData}
        setOpenPdfModal={setOpenPdfModal}
        setMessagesWithAds={setMessagesWithAds}
      />
    </>
  )
}

export default ChatWidget
